import { MigrationManifest, PersistConfig, PersistMigrate, createMigrate, getStoredState } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { FeatureRollout, YammerState } from '../state/types';

export { FeatureRollout, createMigrate };
export type { MigrationManifest };

export interface GetPersistConfigProps {
  readonly key: string;
  readonly version?: number;
  readonly migrate?: PersistMigrate;
  readonly allowlist?: (keyof YammerState)[];
}

type GetPersistConfig = <T extends YammerState>(props: GetPersistConfigProps) => PersistConfig<T>;
export const getPersistConfig: GetPersistConfig = ({ key, version, migrate, allowlist = [] }) => ({
  storage,
  key,
  version,
  migrate,
  whitelist: allowlist,
});

export type GetPersistedState = (key: string) => Promise<Partial<YammerState> | undefined>;
export const getPersistedState: GetPersistedState = async (key) => getStoredState(getPersistConfig({ key }));
